<template>
  <div class="col-md-8 col-lg-4 pd-5">
    <div class="card p-1 mb-0">
      <div class="d-flex justify-content-between">
        <span>{{ statisticsItem[itemKey].name }}</span>

        <select
          @change="$emit('onDateChange', statisticsItem[itemKey])"
          v-model="statisticsItem[itemKey].date_range"
          class="form-control form-control-sm width-150"
          style="padding: 0; border: none; text-align: right"
        >
          <option value="" disabled selected>Select Range</option>
          <option
            v-for="(range, j) in timeRange"
            :key="j"
            :value="range.value"
          >
            {{ range.name }}
          </option>
        </select>
      </div>
      <hr>
      <p class="text-center center-position" v-if="statisticsItem[itemKey].labels.length == 0">Not data available</p>
      <PieChart v-else
        :chartData="{
          labels: statisticsItem[itemKey].labels,
          datasets: statisticsItem[itemKey].data_sets
        }"
        :chartOptions="chartOptions"/>
    </div>
  </div>
</template>

<script setup>
import PieChart from '@/components/atom/chart/pieChart';

defineProps({
  statisticsItem: Object,
  page: Object,
  timeRange: Array,
  itemKey: String
})

const generateChartDataDetails = (chart) => {
  const data = chart.data;
  const dataset = data.datasets[0];
  const total = dataset.data.reduce((sum, val) => sum + val, 0);

  return data.labels.map((label, i) => {
    const value = dataset.data[i];
    const percentage = ((value / total) * 100).toFixed(1);

    return {
      index: i,
      label,
      value,
      percentage,
      color: dataset.backgroundColor[i],
      borderColor: dataset.backgroundColor[i],
      hidden: chart.getDatasetMeta(0).data[i].hidden
    };
  });
};

const chartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  cutout: '70%',
  plugins: {
    legend: {
      position: 'bottom',
      labels: {
       generateLabels: (chart) => {
          return generateChartDataDetails(chart)
            .sort((a, b) => b.percentage - a.percentage)
            .map(item => ({
              text: `${item.label} - ${item.percentage}%`,
              fillStyle: item.color,
              strokeStyle: item.borderColor,
              lineWidth: 1,
              hidden: item.hidden,
              index: item.index
          }));
        }
      }
    },
    tooltip: {
      callbacks: {
        label: function (context) {
          const chart = context.chart;
          const details = generateChartDataDetails(chart)[context.dataIndex];
          return `${details.label}: ${details.value} (${details.percentage}%)`;
        }
      }
    }
  }
};
</script>
